export type GuestFilesystemRow = {
  id: string;
  mount: string;
  type: string;
  capacityBytes: number | null;
  usedBytes: number | null;
  freeBytes: number | null;
  utilizationPercent: number | null;
};

export function guestFilesystemRows(metadata: Record<string, unknown>): GuestFilesystemRow[] {
  const rows = new Map<string, Partial<GuestFilesystemRow>>();
  for (const [key, value] of Object.entries(metadata)) {
    const match =
      /^guestFilesystem\.([^.]+)\.(mount|type|capacityBytes|usedBytes|freeBytes|utilizationPercent)$/.exec(
        key,
      );
    if (!match) continue;
    const id = match[1]!;
    const field = match[2]!;
    const row = rows.get(id) ?? { id };
    if (field === 'mount' || field === 'type') row[field] = String(value ?? '');
    else {
      const number = Number(value);
      row[field as 'capacityBytes' | 'usedBytes' | 'freeBytes' | 'utilizationPercent'] =
        Number.isFinite(number) ? number : null;
    }
    rows.set(id, row);
  }
  return [...rows.values()]
    .map((row) => ({
      id: row.id ?? 'unknown',
      mount: row.mount ?? '',
      type: row.type ?? '',
      capacityBytes: row.capacityBytes ?? null,
      usedBytes: row.usedBytes ?? null,
      freeBytes: row.freeBytes ?? null,
      utilizationPercent: row.utilizationPercent ?? null,
    }))
    .sort(
      (left, right) => left.mount.localeCompare(right.mount) || left.id.localeCompare(right.id),
    );
}
